import api from './api';

const getAnnouncements = () => {
  function runAnnouncementscheck() {
    api.chatroom
      .getAnnouncements()
      .then((response) => response.data)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        console.error(err);
      });
    setTimeout(runAnnouncementscheck, 3000);
  }

  runAnnouncementscheck();
};

export default getAnnouncements;
